export const unsafePatternRegExp = /(<|>|{|}|((https?:)?\/\/|www\.)[^\/\s]+|{{.*}})/i;
export const alphanumericRegExp = /^[a-zA-Z0-9]*$/;
export const urlProtocolPatternRegExp = new RegExp('^http(s?):/{2}', 'i');
export const urlPatternRegExp = new RegExp('((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-z#\\d%@_.~+&:]*)*' + // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i');
export const emailRegExp = 
// same as backend email validation, https://github.com/ajv-validator/ajv-formats/blob/master/src/formats.ts#L65
/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const importAngularDependenciesRegExp = /^(?!.*\.(spec|test)\.(js|ts)$).*\.(js|ts)$/;
